import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Loop,
  title: 'Loop',
  category: ComponentCategory.Layout,
  droppable: true,
};
